import React from "react";
import { Table } from '@themesberg/react-bootstrap';

const TableRow = (props) => {
  const { numbers, rIndex, playMethod, rewardAmount, rewards, matchedNumbers, matchedSpecialNumber, sharedJackpotValue } = props;

  if (rewards && rewards.length > 0) {

    let normalNumbers = []
    let specialNumbers = []

    if (playMethod.includes('GROUP_SPECIAL_')) {
      const specialLength = playMethod.split('GROUP_SPECIAL_')[1]
      normalNumbers = numbers.split(' ').slice(0, 5)
      specialNumbers = numbers.split(' ').slice(-specialLength)
    } else {
      normalNumbers = numbers.split(' ').slice(0, numbers.split(' ').length - 1)
      specialNumbers = numbers.split(' ').slice(-1)
    }

    return (
      <tr>
        <td>
          {['A', 'B', 'C', 'D', 'E', 'F'][rIndex]}
        </td>
        <td>
          {normalNumbers.map((it, idx) => {
            const isMatched = matchedNumbers.indexOf(it) >= 0
            if (isMatched) {
              return <span className={`text-danger`}> &nbsp;{it} &nbsp;</span>
            }
            return <span className={`text-primary`}> &nbsp;{it} &nbsp;</span>
          })} |
          {specialNumbers.map((it, idx) => {
            const isMatched = matchedSpecialNumber.indexOf(it) >= 0
            if (isMatched) {
              return <span className={`text-danger`}> &nbsp;{it} &nbsp;</span>
            }
            return <span className={`text-primary`}> &nbsp;{it} &nbsp;</span>
          })}
        </td>
        <td>{parsePlayMethod(playMethod)}</td>
        <td>{rewards[0].name}</td>
        <td className="align-items-right">{new Intl.NumberFormat('vn-VI', {}).format(rewardAmount) || ""}</td>
        <td className="align-items-right">{new Intl.NumberFormat('vn-VI', {}).format(sharedJackpotValue) || ""}</td>
        <td className="align-items-right">{new Intl.NumberFormat('vn-VI', {}).format(Number(rewardAmount) + Number(sharedJackpotValue)) || ""}</td>
      </tr>
    );
  }
  return null;
};

export default ({ numberRows }) => {
  return (
    <Table responsive className="align-items-center table-flush">
      <thead className="thead-light">
        <tr>
          <th scope="col">STT</th>
          <th scope="col">Dãy số</th>
          <th scope="col">Cách chơi</th>
          <th scope="col">Tên giải thưởng</th>
          <th scope="col">Giá trị</th>
          <th scope="col">Giá trị chia giải thưởng</th>
          <th scope="col">Tổng</th>
        </tr>
      </thead>
      <tbody>
        {numberRows && numberRows.map((pv, index) => <TableRow rIndex={index} key={`rows-keys-lottmekong-${pv.id}`} {...pv} />)}
      </tbody>
    </Table>
  );
}

const parsePlayMethod = (method) => {
  switch (method) {
    case 'GROUP_NORMAL_15':
      return 'Bao 15'
    case 'GROUP_NORMAL_14':
      return 'Bao 14'
    case 'GROUP_NORMAL_13':
      return 'Bao 13'
    case 'GROUP_NORMAL_12':
      return 'Bao 12'
    case 'GROUP_NORMAL_11':
      return 'Bao 11'
    case 'GROUP_NORMAL_10':
      return 'Bao 10'
    case 'GROUP_NORMAL_9':
      return 'Bao 9'
    case 'GROUP_NORMAL_8':
      return 'Bao 8'
    case 'GROUP_NORMAL_7':
      return 'Bao 7'
    case 'GROUP_NORMAL_6':
      return 'Bao 6'
    case 'GROUP_NORMAL_5':
      return 'Vé thường'
    case 'GROUP_NORMAL_4':
      return 'Bao 4'
    case 'GROUP_SPECIAL_2':
      return 'Bao 2 đặc biệt'
    case 'GROUP_SPECIAL_3':
      return 'Bao 3 đặc biệt'
    case 'GROUP_SPECIAL_4':
      return 'Bao 4 đặc biệt'
    case 'GROUP_SPECIAL_5':
      return 'Bao 5 đặc biệt'
    case 'GROUP_SPECIAL_6':
      return 'Bao 6 đặc biệt'
    case 'GROUP_SPECIAL_7':
      return 'Bao 7 đặc biệt'
    case 'GROUP_SPECIAL_8':
      return 'Bao 8 đặc biệt'
    case 'GROUP_SPECIAL_9':
      return 'Bao 9 đặc biệt'
    case 'GROUP_SPECIAL_10':
      return 'Bao 10 đặc biệt'
    case 'GROUP_SPECIAL_11':
      return 'Bao 11 đặc biệt'
    case 'GROUP_SPECIAL_12':
      return 'Bao 12 đặc biệt'
    default:
      break;
  }
}